
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshAccessToken } from '../store/auth';


export default function useTokenAutoRefresh() {
  const dispatch = useDispatch();
  const { tokenExpiry, refreshToken, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!token || !refreshToken || !tokenExpiry) return;

    const now = Date.now();
    const timeout = tokenExpiry - now - 60 * 1000;

    if (timeout <= 0) {
      dispatch(refreshAccessToken());
      return;
    }

    const timer = setTimeout(() => {
      dispatch(refreshAccessToken());
    }, timeout);

    return () => clearTimeout(timer);
  }, [token, tokenExpiry, refreshToken, dispatch]);
}
